<template>
  <BaseWrapper :loading="loading">
    <div class="mb-4 flex justify-end gap-2">
      <MitraPeriodSelect v-model="filter.periodId" @change="loadOffices" />
      <BaseInput type="text" :shadow="false" placeholder="Kode Stockist" debounce v-model="filter.code"
        @native-input="loadOffices" />
      <BaseDropdown width="150px">
        <template #toggle="{ toggle }">
          <BaseButton @click="toggle" :loading="loadingExport">Export</BaseButton>
        </template>

        <template #content="{ close }">
          <button class="p-2 text-sm text-gray-700 w-full hover:bg-gray-50 text-left"
            @click="onExport('pdf', close)">Export PDF</button>
          <button class="p-2 text-sm text-gray-700 w-full hover:bg-gray-50 text-left"
            @click="onExport('csv', close)">Export Excel</button>
        </template>
      </BaseDropdown>
    </div>
    <Datatable :columns="columns" :total="offices.meta.page.total" :perPage="offices.meta.page.perPage"
      :currentPage="offices.meta.page.currentPage" :meta="offices.meta" cursor @pagechanged="onChangePage">
      <template #tbody="{ classes }">
        <tr v-for="(office, index) in offices.data" :key="index" :class="[classes.tr, 'bg-white']">
          <td :class="[classes.td]">
            {{ office.attributes.code }}
          </td>
          <td :class="[classes.td]">
            {{ getOffice(office, 'total_mitra_n') | toCurrency }}
          </td>
          <td :class="[classes.td]">
            {{ getOffice(office, 'total_mitra_nd') | toCurrency }}
          </td>
          <td :class="[classes.td]">
            {{ getOffice(office, 'total_mitra_ne') | toCurrency }}
          </td>
          <td :class="[classes.td]">
            {{ getCashbill(office, 'total') | toCurrency }}
          </td>
          <td :class="[classes.td]">
            {{ getCashbill(office, 'total_pv') | toCurrency }}
          </td>
          <td :class="[classes.td]">
            {{ getCashbill(office, 'total_bv') | toCurrency }}
          </td>
          <td :class="[classes.td]">
            {{ getCashbillPrice(office, 'total_stockist_price') | toCurrency }}
          </td>
          <td :class="[classes.td]">
            {{ getCashbillPrice(office, 'total_mitra_usaha_price') | toCurrency }}
          </td>
          <td :class="[classes.td]">
            {{ getCashbillPrice(office, 'total_konsumen_price') | toCurrency }}
          </td>
        </tr>
      </template>
      <template v-if="offices.data.length" #tfoot="{ classes }">
        <tr :class="[classes.tr, 'bg-gray-50']">
          <td :class="[classes.td]">
            <p class="text-gray-900 font-bold">Total</p>
          </td>
          <td :class="[classes.td]">
            {{ +offices.meta.summary_mitra.total_mitra_n | toCurrency }}
          </td>
          <td :class="[classes.td]">
            {{ +offices.meta.summary_mitra.total_mitra_nd | toCurrency }}
          </td>
          <td :class="[classes.td]">
            {{ +offices.meta.summary_mitra.total_mitra_ne | toCurrency }}
          </td>
          <td :class="[classes.td]">
            {{ +offices.meta.summary_cashbill.total | toCurrency }}
          </td>
          <td :class="[classes.td]">
            {{ +offices.meta.summary_cashbill.total_pv | toCurrency }}
          </td>
          <td :class="[classes.td]">
            {{ +offices.meta.summary_cashbill.total_bv | toCurrency }}
          </td>
          <td :class="[classes.td]">
            {{ +offices.meta.summary_cashbill_price.total_stockist_price | toCurrency }}
          </td>
          <td :class="[classes.td]">
            {{ +offices.meta.summary_cashbill_price.total_mitra_usaha_price | toCurrency }}
          </td>
          <td :class="[classes.td]">
            {{ +offices.meta.summary_cashbill_price.total_konsumen_price | toCurrency }}
          </td>
        </tr>
      </template>
    </Datatable>
  </BaseWrapper>
</template>

<script>
import { requestMixin } from '../../../../mixins/request/request';
import MitraPeriodSelect from '../../../../components/period/mitra-period/mitra-period-select.vue';
import BaseDropdown from '../../../../components/base/BaseDropdown.vue';
import { mapGetters } from 'vuex';
import { downloadFile } from '../../../../services/utils.service.js';

export default {
  mixins: [requestMixin],
  components: { MitraPeriodSelect, BaseDropdown },
  data() {
    return {
      loading: true,
      loadingExport: false,
      filter: {
        code: null,
        periodId: null
      },
      offices: {
        data: [],
        meta: {
          page: {}
        }
      }
    }
  },
  computed: {
    ...mapGetters({
      getChannelName: 'auth/getChannelName'
    }),
    columns() {
      return [
        { id: 'code', name: 'Kode Stockist' },
        { id: 'n_total', name: 'N' },
        { id: 'nd_total', name: 'ND' },
        { id: 'ne_total', name: 'NE' },
        { id: 'cashbill_total', name: 'Cashbill' },
        { id: 'pv_total', name: 'PV' },
        { id: 'bv_total', name: 'BV' },
        { id: 'hs_total', name: 'HS' },
        { id: 'hm_total', name: 'HM' },
        { id: 'hk_total', name: 'HK' },
      ]
    }
  },
  methods: {
    addExportListener() {
      const userChannel = this.$pusher.channel(this.getChannelName);

      userChannel.bind(
        'Illuminate\\Notifications\\Events\\BroadcastNotificationCreated',
        this.onFinishExport
      );
    },
    async loadCurrentPeriod() {
      const [res, err] = await this.request(`/api/v1/mitra-periods/-actions/get-current-period`)

      if (!err) {
        this.filter.periodId = res.data.id
      }
    },
    async loadOffices(params) {
      this.loading = true

      const [res, err] = await this.request(`/api/v1/offices`, {
        params: {
          'filter[office_category_id]': 4,
          'fields[simple-offices]': 'code',
          'page[limit]': 5,
          'cashbill_report_period_id': this.filter.periodId,
          'mitra_report_period_id': this.filter.periodId,
          'filter[code]': this.filter.code || null,
          ...params
        }
      })

      if (!err) {
        this.offices = res

        this.loadingExport = res.meta.exporting
      }

      this.loading = false
    },
    removeExportListener() {
      const userChannel = this.$pusher.channel(this.getChannelName);

      if (userChannel) {
        userChannel.unbind('Illuminate\\Notifications\\Events\\BroadcastNotificationCreated', this.onFinishExport);
      }
    },
    getOffice(office, type) {
      const mitra = this.offices.meta.mitra.find(mitra => mitra.upline_id == office.id)

      if (!mitra) {
        return 0
      }

      return +mitra[type]
    },
    getCashbill(office, type) {
      const cashbill = this.offices.meta.cashbill.find(cashbill => cashbill.origin_office_id == office.id)

      if (!cashbill) {
        return 0
      }

      return +cashbill[type]
    },
    getCashbillPrice(office, type) {
      const cashbillPrice = this.offices.meta.cashbill_price.find(cashbillPrice => cashbillPrice.origin_office_id == office.id)

      if (!cashbillPrice) {
        return 0
      }

      return +cashbillPrice[type]
    },
    onChangePage(page) {
      this.loadOffices({ ...page })
    },
    async onExport(format, close) {
      close()

      this.loadingExport = true

      const [, err] = await this.request(`/api/v1/offices/-actions/export-cashbill-mitra-report`, {
        method: 'post',
        params: {
          format,
          period_id: this.filter.periodId
        }
      })

      if (err) {
        this.loadingExport = false
      }
    },
    onFinishExport(e) {
      if (e.type === 'App\\Notifications\\CashbillMitraExported') {
        this.loadingExport = false

        downloadFile(e.file_url)
      }
    }
  },
  async created() {
    await this.loadCurrentPeriod()
    this.loadOffices()
    this.addExportListener();
  },
  beforeRouteLeave(to, from, next) {
    this.removeExportListener();
    next();
  },
}
</script>